(() => {
  if (window.__peakImageLoaderInitialized) return;
  window.__peakImageLoaderInitialized = true;

  const DELAY = 800;
  const HOST_SELECTOR = [
    '.media',
    '.card__media',
    '.peak-builder__product-image',
    '.product__media',
    '.banner__media',
    '.slideshow__media',
    '.gallery-item',
    '.portfolio-card',
    '.image-with-text__media',
    '.collage-card__image-wrapper',
    '.multicolumn-card__image-wrapper'
  ].join(',');

  const cleanup = img => {
    if (img._peakLoaderTimer) {
      clearTimeout(img._peakLoaderTimer);
      img._peakLoaderTimer = null;
    }
    const spinner = img._peakSpinner;
    if (!spinner) return;
    const host = spinner.parentElement;
    spinner.remove();
    img._peakSpinner = null;
    if (host && !host.querySelector('.peak-image-spinner')) {
      host.classList.remove('peak-image-loader-host');
    }
  };

  const show = img => {
    if (img.complete || img._peakSpinner || !img.isConnected) return;
    const host = img.closest(HOST_SELECTOR) || img.parentElement;
    if (!host) return;

    host.classList.add('peak-image-loader-host');
    const spinner = document.createElement('span');
    spinner.className = 'peak-image-spinner';
    spinner.setAttribute('aria-hidden', 'true');
    host.appendChild(spinner);
    img._peakSpinner = spinner;
  };

  const watch = img => {
    if (!(img instanceof HTMLImageElement) || img.complete || img.dataset.peakLoaderBound === 'true') return;
    img.dataset.peakLoaderBound = 'true';

    img.addEventListener('load', () => cleanup(img), { once: true });
    img.addEventListener('error', () => cleanup(img), { once: true });
    img._peakLoaderTimer = window.setTimeout(() => show(img), DELAY);
  };

  const scan = scope => {
    if (scope instanceof HTMLImageElement) {
      watch(scope);
      return;
    }
    if (scope.querySelectorAll) scope.querySelectorAll('img').forEach(watch);
  };

  const start = () => {
    scan(document);
    const observer = new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) scan(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
